// ProfileDropdown.js
import React from 'react';
import { LogOut, User } from 'lucide-react'; // Import Lucide icons for consistency

/**
 * ProfileDropdown component for user profile actions.
 * @param {function(): void} onLogout - Callback for logout action.
 * @param {function(): void} onProfileClick - Callback for navigating to the profile page.
 */
const ProfileDropdown = ({ onLogout, onProfileClick }) => {
    return (
        <div className="flex flex-col">
            <button
                onClick={onProfileClick} // This now correctly calls the onProfileClick prop
                className="flex items-center px-4 py-2 text-gray-700 hover:bg-gray-100 w-full text-left rounded-md"
            >
                <User className="w-4 h-4 mr-2" />
                Profile
            </button>
            <button
                onClick={onLogout}
                className="flex items-center px-4 py-2 text-red-600 hover:bg-red-50 w-full text-left rounded-md"
            >
                <LogOut className="w-4 h-4 mr-2" />
                Logout
            </button>
        </div>
    );
};

export default ProfileDropdown;
